export enum BurnAssessment {
  Unknown = "Unknown",
  Good = "Good",
  Normal = "Normal",
  Bad = "Bad",
}
